export default __webpack_public_path__ + "static/media/user.c90162d4.svg";